import React from "react";

const ArrowRight = () => {
  return (
    <svg
      className="arrow-right"
      width="36"
      height="41"
      fill="none"
      viewBox="0 0 36 41"
    >
      <path
        fill="#466645"
        d="M13.764.653A2.233 2.233 0 0016.92 3.81 2.233 2.233 0 0013.764.653z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M19.704 6.592a2.23 2.23 0 103.153 3.156 2.23 2.23 0 00-3.153-3.156z"
      ></path>
      <path
        fill="#466645"
        d="M25.642 12.532a2.23 2.23 0 103.154 3.156 2.23 2.23 0 00-3.154-3.156zM31.583 18.471a2.23 2.23 0 103.153 3.156 2.23 2.23 0 00-3.153-3.156zM13.764 39.445a2.233 2.233 0 013.156-3.156 2.233 2.233 0 01-3.156 3.156z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M19.704 33.505a2.23 2.23 0 113.153-3.156 2.23 2.23 0 01-3.153 3.156z"
      ></path>
      <path
        fill="#466645"
        d="M25.642 27.566a2.23 2.23 0 010-3.155 2.23 2.23 0 013.155 0 2.23 2.23 0 010 3.155 2.23 2.23 0 01-3.155 0z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M31.583 21.627a2.23 2.23 0 113.153-3.156 2.23 2.23 0 01-3.153 3.156zM.653.653A2.233 2.233 0 003.81 3.81 2.233 2.233 0 00.653.653z"
      ></path>
      <path
        fill="#466645"
        d="M6.594 6.592A2.233 2.233 0 009.75 9.748a2.233 2.233 0 00-3.156-3.156z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M12.532 12.532a2.23 2.23 0 103.153 3.156 2.23 2.23 0 00-3.153-3.156z"
      ></path>
      <path
        fill="#466645"
        d="M18.471 18.471a2.23 2.23 0 103.154 3.156 2.23 2.23 0 00-3.154-3.156z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M.653 39.445A2.233 2.233 0 013.81 36.29a2.233 2.233 0 01-3.156 3.156z"
      ></path>
      <path
        fill="#466645"
        d="M6.594 33.505A2.233 2.233 0 019.75 30.35a2.233 2.233 0 01-3.156 3.156z"
      ></path>
      <path
        fill="#466645"
        fillOpacity="0.3"
        d="M12.532 27.566a2.23 2.23 0 113.156-3.157 2.23 2.23 0 01-3.156 3.157z"
      ></path>
      <path
        fill="#466645"
        d="M18.471 21.627a2.23 2.23 0 113.154-3.156 2.23 2.23 0 01-3.154 3.156z"
      ></path>
    </svg>
  );
};

export default ArrowRight;
